module.exports = __webpack_public_path__ + "static/media/Vector-16.e82ec060.svg";